import { app } from '../../../app';
import { Controller } from './google-info.controller';

app.component('googleInfo', {
    templateUrl: require('./google-info.html'),
    controller: Controller,
});



// WEBPACK FOOTER //
// ./src/portal/states/public/google-info/google-info.component.js